/** LO-02 rail icon (eager, tiny): a little skyline with a download arrow. */
import type { JSX } from 'preact';

export function CitiesIcon({ size = 26 }: { size?: number }): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <path d="M3 28V14h7v14M10 28V7h9v21M19 28V16h8v12z" fill="#8e6cef" stroke="#4a2c2a" stroke-width="2.2" stroke-linejoin="round" />
      <path d="M13 11h3M13 15h3M13 19h3M5.5 18h2M21.5 20h3" stroke="#fff8ec" stroke-width="1.8" stroke-linecap="round" />
      <circle cx="24" cy="8" r="6.5" fill="#2ec4b6" stroke="#4a2c2a" stroke-width="2" />
      <path d="M24 4.8v5.6M21.4 8.2 24 10.8l2.6-2.6" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M2 28h28" stroke="#4a2c2a" stroke-width="2.2" stroke-linecap="round" />
    </svg>
  );
}
